/// <reference path="../jQuery/jquery-1.7.1.min-vsdoc.js" />
/// <reference path="../jQuery/jquery.ui.slider.min.js" />
/// <reference path="ErrorDialog.js" />



var LocalizationMessages;
var LocalizationMetricsMessages;
var LocalizationWarnings;

$(document).ready(function () {


    
    $("body").on("click", ".imageItem", function (e) {
        //Throw event for pages to handle
        $.event.trigger({
            type: "imageClicked",
            iID: $(this).find(".imageBtn").attr("imageID"),
            img: $(this).find(".imageBtn")
        });

        $("#imgViewerPopup").dialog("close");
    });

    $("body").on("click", ".customBadgeLauncher", function (e) {

        LanguageWebService.LoadSection("Manual_Badges",

            function (result) {
                LocalizationMessages = result;
            },
            /*function (error) { showErrorMessage(error.get_message()); }*/
        );

        LanguageWebService.LoadSection("ManualBadge_Messages",

            function (result) {
                LocalizationWarnings = result;
            },
            /*function (error) { showErrorMessage(error.get_message()); }*/
        );

        

        var $clicked = $(e.target);
        var $popup = $(".customBadgePopup");
        if (LocalizationMessages === undefined) {
            LocalizationMessages = new Array();
            LocalizationMessages["Show_All_Items"] = "Show All Items";
        } 

        if (LocalizationWarnings === undefined) {
            LocalizationWarnings = new Array();

        } //end if


        $popup.dialog({
            autoOpen: false,
            closeText: '',
            width: 641,
            position: { my: "center", at: "center", of: window },
            modal: true,
            resizable: false,
            open: function (e) {                
                $(this).parent().appendTo($(this).parents("form").first());
                $(this).css("min-height", "385px");                
            },
            beforeClose: function (e) {
                if (CustomBadge.Properties.ShowConfirmOnClose) {
                    var dialogSettings = new CVDialogs.DialogSettings();
                    dialogSettings.dialogType = CVDialogs.DialogTypes.Warning;
                    dialogSettings.buttons = CVDialogs.ButtonGroups.YesNo;                    
                    SimpleDialog((LocalizationWarnings === undefined) ? "Confirm Exit" : LocalizationWarnings["Warning_On_Exit_Title"][0], (LocalizationWarnings === undefined) ? "Are you sure you want to close? All progress on the current badge will be lost." : LocalizationWarnings["Warning_On_Exit"][0], dialogSettings,
                        function (result) {
                            switch (result) {
                                case CVDialogs.DialogResult.Yes:
                                    CustomBadge.Properties.ShowConfirmOnClose = false;
                                    $popup.dialog("close");                                    
                                    break;                                
                            }
                        }
                    );

                    return false;
                }
            },
            close: function (e) {
                CustomBadge.DeleteUploadedTmpFiles();
                CustomBadge.ResetToDefaults();
            },
            title: (LocalizationMessages === undefined) ? "Create Badge" : LocalizationMessages["Create_Badge_Title"][0]

        });

        $popup.dialog("open");

        //Uploader class fd-file needs to be above dialog z index!
        $popup.find(".fd-file").css("z-index", parseInt($popup.parents(".ui-dialog").css("z-index")) + 1);
        CustomBadge.ShowStep($popup, 1);
    });

    //Setup custom badge creation popup controls
    CustomBadge.Init();

    //Setup events for the custom badge creation popup
    CustomBadge.Events.WireEvents();
});

function showImageViewerPopup() {
    LanguageWebService.LoadSection("Metrics",
        function (result) {
            LocalizationMetricsMessages = result;
        },
        /*function (error) { showErrorMessage(error.get_message()); }*/);
    var $popup = $("#imgViewerPopup");

    $popup.dialog({
        autoOpen: false,
        closeText: '',
        width: 641,
        height: 350,
        position: { my: "center", at: "center", of: window },
        resizable: false,
        modal: true,
        open: function (e) {
            $(this).parent().appendTo($(this).parents("form:first"));            
        },
        title: LocalizationMetricsMessages["Choose_Image"][0]
    });

    $popup.dialog("open");
}

var CustomBadge = CustomBadge || {
    Properties: {
        ShowConfirmOnClose: true,
        IsModify: false,
        LastGeneratedImageID: -1,
        UploadedFilenames: [],
        IconScale: 75
    },

    NextStep: function () {
        var $popup = $(".customBadgePopup");
        if ($popup == null || $popup.length < 1) return;
        //var currentStep = $popup.find("[step]:not(.hidden)").first().attr("step");
        var currentStep = $popup.find(".wizardNavigationSegment.selected").attr("step");
        var nextStep = parseInt(currentStep) + 1;

        nextStep = Math.min(4, nextStep);
        CustomBadge.ShowStep($popup, nextStep);

        //If the step is actually changing, fire the navigation changed event
        if (nextStep != currentStep)
            CustomBadge.Events.Triggers.TriggerNavigationStepChanged(currentStep, nextStep);
    },
    PreviousStep: function () {
        var $popup = $(".customBadgePopup");
        if ($popup == null || $popup.length < 1) return;
        //var currentStep = $popup.find("[step]:not(.hidden)").first().attr("step");
        var currentStep = $popup.find(".wizardNavigationSegment.selected").attr("step");
        var nextStep = parseInt(currentStep) - 1;

        nextStep = Math.max(1, nextStep);
        CustomBadge.ShowStep($popup, nextStep);

        //If the step is actually changing, fire the navigation changed event
        if (nextStep != currentStep)
            CustomBadge.Events.Triggers.TriggerNavigationStepChanged(currentStep, nextStep);
    },
    ShowStep: function ($popup, step, fireNavigateEvent) {
        if ($popup == null)
            $popup = $(".customBadgePopup");

        //hide content of all steps
        $popup.find("[step]").not(".wizardNavigationSegment").addClass("hidden");
        //show selected step's content
        $popup.find("[step=" + step + "]").removeClass("hidden");

        //remove selected from all navigation buttons
        $popup.find(".wizardNavigationSegment").removeClass("selected");
        //add selected to proper navigation button
        $popup.find(".wizardNavigationSegment[step=" + step + "]").addClass("selected");

        if (fireNavigateEvent != undefined && fireNavigateEvent == true)
            CustomBadge.Events.Triggers.TriggerNavigationStepChanged(-1, step);            
    },

    RecustomizeFromBeginning: function () {
        CustomBadge.Properties.IsModify = true;
        CustomBadge.ShowStep(null, 1, true);
        $(".customBadgeCompletedPreview").attr("src", "");
    },

    ResetToDefaults: function () {
        CustomBadge.Properties.ShowConfirmOnClose = true;
        CustomBadge.Properties.IsModify = false;
        CustomBadge.Properties.LastGeneratedImageID = -1;
        CustomBadge.Properties.UploadedFilenames = [];
        $("#ckbCustomBadgeWhiteOut").attr("checked", "checked");
        $(".customBadgeThumbnail").find("img").remove();
        CustomBadge.ShowStep(null, 1, true);
    },

    UnhideCorrectBackgroundForPreview: function($popup, bkgType) {
        var $backgroundPreviews = $popup.find(".customBadgeBackgroundLayerContainer").find("[bkgType]");
        var $shader = $popup.find(".customBadgeRightSideShader");
        var $foreground = $popup.find(".customBadgeIconPlaceholder").find("img");
        
        $backgroundPreviews.addClass("hidden");
        $popup.find(".customBadgeBackgroundLayerContainer").find("[bkgType=" + bkgType + "]").removeClass("hidden");

        if (bkgType == 0) { //no background picked
            $(".customBadgeColorPickerHolder").addClass("hidden");
            $(".customBadgeCustomizeOptionsContainer").addClass("hidden");
            $("#ckbCustomBadgeRightShader").removeAttr("checked");
            $("#ckbCustomBadgeWhiteOut").removeAttr("checked");
            $shader.addClass("hidden");
            $foreground.removeClass("customBadgeIconWhiteout");
            $(".customBadgePreview").addClass("centered");
            $(".customBadgeInfieldHolder").addClass("centered");
        }
        else {
            $(".customBadgeColorPickerHolder").removeClass("hidden");
            $(".customBadgeCustomizeOptionsContainer").removeClass("hidden");
            $("#ckbCustomBadgeRightShader").attr("checked", "checked");
            $("#ckbCustomBadgeWhiteOut").attr("checked", "checked");
            $shader.removeClass("hidden");
            $foreground.addClass("customBadgeIconWhiteout");
            $(".customBadgePreview").removeClass("centered");
            $(".customBadgeInfieldHolder").removeClass("centered");
        }
    },

    ChangeBackgroundColor: function ($popup, bkgColor) {
        $popup.find(".customBadgeBackgroundColorLayer").css("background-color", bkgColor);
        $popup.find(".customBadgeBackgroundColorLayer").attr("cbtint", bkgColor);
    },

    DeactivateCustomBadge: function (imageID) {
        GoalsService.DeactivateCustomBadge(imageID,
            function (result) {
                $(".customBadgeItem img[imageid=" + imageID + "]").parent().remove();
            },
            function (error) { showErrorDialog(error.get_message(), "Error Deactivating Custom Badge") }
        );
    },

    SaveCustomBadge: function() {
        var fileName = $("[id*=hdnFileName]:last").val();
        var jCropTop, jCropLeft, jCropWidth, jCropHeight;
        var split = $("[id*=hdnFileDimensions]:last").val().split('|');
        jCropWidth = parseInt(split[0]);
        jCropHeight = parseInt(split[1]);
        jCropLeft = parseInt(split[2]);
        if (jCropLeft < 0) jCropLeft = 0;
        jCropTop = parseInt(split[3]);
        if (jCropTop < 0) jCropTop = 0;

        if (isNaN(jCropTop) || jCropTop == null) jCropTop = 0;
        if (isNaN(jCropLeft) || jCropLeft == null) jCropLeft = 0;
        if (isNaN(jCropWidth) || jCropWidth == null) jCropWidth = 0;
        if (isNaN(jCropHeight) || jCropHeight == null) jCropHeight = 0;

        var $jCropContainer = $(".jcrop-holder");
        var jCropContainerWidth = $jCropContainer.length > 0 ? $jCropContainer.width() : 0;
        var jCropContainerHeight = $jCropContainer.length > 0 ? $jCropContainer.height() : 0;

        var backgroundType = $(".customBadgePreview").find(".customBadgeBackgroundLayerContainer").first().find(".customBadgeBackgroundLayer").not(".hidden").attr("bkgType")
        var tint = $(".customBadgePreview").find(".customBadgeBackgroundColorLayer").attr("cbtint");
        var whiteout = $("#ckbCustomBadgeWhiteOut").is(":checked");
        var useShade = $("#ckbCustomBadgeRightShader").is(":checked");
        var badgeName = $("#txbCustomBadgeName").val();        

        //if (CustomBadge.Properties.IsModify) {
        //    GoalsService.ModifyCustomBadge(CustomBadge.Properties.LastGeneratedImageID, badgeName, fileName, backgroundType, tint, whiteout, useShade, jCropTop, jCropLeft, jCropWidth, jCropHeight, jCropContainerWidth, jCropContainerHeight,
        //        function (result) {
        //            CustomBadge.PushToList(result);
        //            CustomBadge.LoadImageForFinalPreview(result.ImageID);
        //        },
        //        function (error) {
        //            showErrorDialog(error.get_message(), "Custom Badge Creation Error");
        //        }
        //    );
        //}
        //else {
            GoalsService.SaveCustomBadge(CustomBadge.Properties.LastGeneratedImageID, fileName, badgeName, backgroundType, tint, whiteout, useShade, CustomBadge.Properties.IconScale / 100, jCropTop, jCropLeft, jCropWidth, jCropHeight, jCropContainerWidth, jCropContainerHeight,
                function (result) {
                    CustomBadge.PushToList(result);
                    CustomBadge.LoadImageForFinalPreview(result.ImageID);
                },
                function (error) {
                    showErrorDialog(error.get_message(), "Custom Badge Creation Error");
                }
            );
        //}

        CustomBadge.NextStep();
    },

    ConfirmCrop: function () {
        var $cropWindow = $(".imgUploadedContainer[pvid='customBadgeThumbnail']");
        
        if ($cropWindow.length > 0 && !($cropWindow.hasClass("hidden"))) {           
            $cropWindow.find(".imgAccept").trigger("click");
        }
    },

    PushToList: function (image) {
        var $separator = $(".imgViewerPopup").find(".imageTypeSeparator");
        var $templateClone = $($(".imageViewerTemplates").find(".customBadgeItemTemplate").html()).clone();
        var $cloneImg = $templateClone.find("img.imageBtn");
        //var $nonTemplateCustomBadges = $(".customBadgeItem").filter(function () { return !($(this).parent().is(".customBadgeItemTemplate")); }) //get all customBadgeItems that don't come from a template
        var newSrc = "../Admin/ImageResizer.aspx?imgid=" + image.ImageID + "&w=72&h=64";
        var $existingBadge = $(".imgViewerPopup").find("img[imageid=" + image.ImageID + "]").parent();

        $cloneImg.attr("src", newSrc);
        $cloneImg.attr("title", image.AltText);
        $cloneImg.attr("imageid", image.ImageID);

        if ($existingBadge.length > 0)
            $existingBadge.remove();

        $templateClone.insertBefore($separator);        
    },

    LoadImageForFinalPreview: function (imageID) {
        var $popup = $(".customBadgePopup");
        $popup.find(".customBadgeFinal").removeClass("hidden").find("img").attr("src", "../Admin/ImageResizer.aspx?imgid=" + imageID + "&w=200&h=225");
        $popup.find(".customBadgeFinalNotGeneratedYet").addClass("hidden");

        CustomBadge.Properties.LastGeneratedImageID = imageID;        
    },

    SelectAndFinish: function () {
        var $popup = $(".customBadgePopup");
        var $imgViewer = $(".imgViewerPopup");

        $popup.dialog("close");
        $imgViewer.find(".customBadgeItem img[imageid=" + CustomBadge.Properties.LastGeneratedImageID + "]").parent().trigger("click");
    },

    DeleteUploadedTmpFiles: function () {
        if (CustomBadge.Properties.UploadedFilenames != null && CustomBadge.Properties.UploadedFilenames.length > 0) {
            //Remove the tmp files.  Callbacks are provided for any fail that happens to occur silently.
            GoalsService.RemoveUploadedTmpFiles(CustomBadge.Properties.UploadedFilenames,
                function(result) { },
                function(error) { }
            );
        }
    },

    Init: function () {        
        $("#customBadgeColorPicker").spectrum({
            flat: true,
            color: '#3cbdd9',
            showInput: true,
            showPalette: true,
            palette: [
                ['red', 'green', 'blue', 'black', 'orange', 'purple', 'yellow', '#0066FF', '#3CBDD9']
            ],
            showSelectionPalette: true,
            localStorageKey: "customBadge.step3",
            maxSelectionSize: 9,
            showInitial: true,
            preferredFormat: "hex",
            showButtons: false,
            move: CustomBadge.Events.handleBackgroundColorChanged
        });

        $("#txtCustomBadgeScaleSlider").slider({
            min: 0,
            max: 100,
            value: 75,
            create: function (event, ui) {
                //$(this).find(".ui-slider-handle").css({ "width": "6px", "height": "15px", "top": "-5px", "text-align": "center", "font-size": "10px", "text-decoration": "none" }).removeClass("ui-corner-all");
                //$(this).css("height", "6px");
                CustomBadge.Events.handleScaleSliderChanged(null, { value: 75 });
            },
            slide: CustomBadge.Events.handleScaleSliderChanged
        });
    },

    Events: {
        WireEvents: function () {
            $(document).on("click", ".customBadgeBackgroundItem", CustomBadge.Events.handleBackgroundClicked);
            $(document).on("change", "#ckbCustomBadgeRightShader", CustomBadge.Events.handleChkUseShadingChanged);
            $(document).on("change", "#ckbCustomBadgeWhiteOut", CustomBadge.Events.handleChkWhiteoutChanged);
            $(document).on("Event_CustomBadge.StepNavigation", CustomBadge.Events.handleStepNavigation);
            $("body").on("click", ".customBadgeDeactivateIcon", CustomBadge.Events.handleDeactivateClicked);
            $(document).on("saveUploadedImage", CustomBadge.Events.handleSaveUploadedImage);
        },

        Triggers: {
            TriggerNavigationStepChanged: function (fromStep, toStep) {
                $.event.trigger({
                    type: "Event_CustomBadge.StepNavigation",
                    navigateFrom: fromStep,
                    navigateTo: toStep
                });
            }
        },

        handleBackgroundClicked: function (e) {
            var $clicked = $(e.target);            
            if (!$clicked.hasClass("customBadgeBackgroundItem"))
                $clicked = $clicked.parents(".customBadgeBackgroundItem");
            var bkgType = $clicked.attr("bkgType");

            $clicked.parents(".customBadgeBackgroundItemHolder").find(".customBadgeBackgroundItem").removeClass("selected");
            $clicked.addClass("selected");

            CustomBadge.UnhideCorrectBackgroundForPreview($clicked.parents(".customBadgePopup"), bkgType);
        },
        handleBackgroundColorChanged: function (color) {
            var colorAsHex = color.toHexString();
            var $popup = $(".customBadgePopup");

            CustomBadge.ChangeBackgroundColor($popup, colorAsHex);
        },
        handleChkUseShadingChanged: function () {
            var $popup = $(".customBadgePopup");
            var $chkUseShader = $popup.find("#ckbCustomBadgeRightShader");
            var isChecked = $chkUseShader.is(":checked");
            var $shader = $popup.find(".customBadgeRightSideShader");
            
            if (isChecked)
                $shader.removeClass("hidden");
            else
                $shader.addClass("hidden");
        },
        handleChkWhiteoutChanged: function () {
            var $popup = $(".customBadgePopup");
            var $chkWhiteout = $popup.find("#ckbCustomBadgeWhiteOut");
            var isChecked = $chkWhiteout.is(":checked");
            var $foreground = $popup.find(".customBadgeIconPlaceholder").find("img");

            if (isChecked)
                $foreground.addClass("customBadgeIconWhiteout");
            else
                $foreground.removeClass("customBadgeIconWhiteout");
        },

        handleStepNavigation: function (e) {
            var $popup = $(".customBadgePopup");
            var toStep = e.navigateTo;
            var fromStep = e.navigateFrom;
            
            if (toStep == 3 || toStep == "3") {
                //preview pane.  Delete the preview foreground and re-clone it.
                var $placeholder = $popup.find(".customBadgeIconPlaceholder");
                var isWhiteOutChecked = $("#ckbCustomBadgeWhiteOut").is(":checked");

                $placeholder.html("");
                $popup.find("#jcrop-thumbnail").parent().clone().appendTo($placeholder);

                if(isWhiteOutChecked)
                    $placeholder.find("#jcrop-thumbnail").addClass("customBadgeIconWhiteout"); //whiteout is default
            }

            if (toStep == 4 || toStep == "4") {
                CustomBadge.Properties.ShowConfirmOnClose = false;
            }
            else {
                CustomBadge.Properties.ShowConfirmOnClose = true;
            }
        },

        handleDeactivateClicked: function (e) {
            var $clicked = $(e.target);
            var imageID = $clicked.parents(".customBadgeItem").find("img").attr("imageid");

            var dialogSettings = new CVDialogs.DialogSettings();
            dialogSettings.dialogType = CVDialogs.DialogTypes.Warning;
            dialogSettings.buttons = CVDialogs.ButtonGroups.YesNo;
            SimpleDialog("Confirm Remove", "Are you sure you want to remove this custom badge?  It will be permanently removed.", dialogSettings,
                function (result) {
                    switch (result) {
                        case CVDialogs.DialogResult.Yes:
                            CustomBadge.DeactivateCustomBadge(imageID);
                            break;
                    }
                }
            );

            e.stopPropagation();
            return false;
        },

        handleSaveUploadedImage: function (e) {
            if (CustomBadge.Properties.UploadedFilenames.indexOf(e.fileName) < 0)
                CustomBadge.Properties.UploadedFilenames.push(e.fileName);
        },

        handleScaleSliderChanged: function (event, ui) {
            //update text value to the right of the slider
            $(".customBadgeScaleSliderAmt").text(ui.value);

            //update the actual scale of the div container and image
            $(".customBadgeIconPlaceholder").css("transform", "scale(" + ui.value / 100 + ")");
            CustomBadge.Properties.IconScale = ui.value;
        },
    }
};
